var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Back ")]),_c('v-btn',{on:{"click":_vm.print}},[_vm._v(" Print ")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }